import { render } from "./SiteLogo.vue?vue&type=template&id=14bdfc7a"
const script = {}

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__